import { ExternalShipmentWithLabelEntity } from "../domain/entities/external_shipment_with_label_entity";
import { ExternalShipmentAffEntity } from "../domain/entities/external_shipment_aff_entity";
import { ExternalShipmentAffPrepareEntity } from "../domain/entities/external_shipment_aff_prepare_entity";
import { ExternalShipmentAffScannedEntity } from "../domain/entities/external_shipment_aff_scanned_entity";
import { ExternalShipmentAffProductsByOrderEntity } from "../domain/entities/external_shipment_aff_products_by_order_entity";
import { ExternalShipmentContract } from "../domain/contracts/external_shipment_contract";
import http from "../../../plugins/http-common";

export const HttpExternalShipmentRepository = {
  ...ExternalShipmentContract,
  model: ExternalShipmentWithLabelEntity,
  aff_model: ExternalShipmentAffEntity,
  aff_prepare_model: ExternalShipmentAffPrepareEntity,
  aff_scanned_model: ExternalShipmentAffScannedEntity,
  aff_model_products_by_order: ExternalShipmentAffProductsByOrderEntity,

  async save_with_label(external_shipment_with_label) {

    const res = await http.post(`external-shipments/with-label`, external_shipment_with_label);

    return res;
  },

  async get_aff_index_orders(status, page, per_page, search, sort_by){
    var sort = ""
    if (sort_by.length > 0) sort = `&sort=${sort_by[0].field}&sort_direction=${sort_by[0].direction}`;

    const res = await http.get(`v1/advanced_external_fulfillment/${status}?page=${page}&per_page=${per_page}&search=${search}${sort}`);

    return res; 
  },

  async aff_prepare_orders(ids) {
    const res = await http.post('v1/advanced_external_fulfillment/prepare_orders', { shipments: ids });
    
    return res;
  },

  async aff_scan_identifier(transaction_id, identifier){
    const res = await http.post(`v1/advanced_external_fulfillment/${transaction_id}/scan`, { identifier: identifier });

    return res;
  },

  async aff_get_products_by_order(id) {
    const res = await http.get(`v1/advanced_external_fulfillment/products_by_shipment/${id}`);

    return res;
  },

  async aff_get_current_session(transaction_id) {
    const res = await http.get(`v1/advanced_external_fulfillment/${transaction_id}`);

    return res;
  },

  async aff_get_barcode_image(shipment_id) {
    const res = await http.get(`external-shipments/${shipment_id}/barcode`, { responseType:'blob' } );
    
    return res;
  }
};